import { LogOut } from 'lucide-react';

import { paths } from 'configuration/paths';
import { NavigationItem } from 'types/navigation';
import { TranslationsKeys } from 'types/translation';
import { useAuthentication } from 'hooks/useAuthentication';
import { useTranslate } from 'hooks/useTranslate';

export const useNavigationItems = (): { navigationItems: NavigationItem[] } => {
  const { user, logout } = useAuthentication();
  const { t } = useTranslate();
  const navigationItems = [
    {
      url: paths.mySurveys,
      text: t(TranslationsKeys.navigationLinks_mySurveys),
      selected: false
    },
    {
      url: paths.surveyIntro,
      text: t(TranslationsKeys.navigationLinks_startNewSurvey),
      selected: false
    },
    {
      url: paths.root,
      text: t(TranslationsKeys.navigationLinks_logoutUser, { userName: user?.fullName ?? '' }),
      selected: false,
      icon: LogOut,
      sticky: true,
      onClick: logout
    }
  ] as NavigationItem[];

  return { navigationItems };
};
